import styled, { keyframes } from "styled-components";

const skeletonLoading = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;
export const CardSkeleton = styled.div`
  height: 3rem;
  width: 100%;
  border-radius: 8px;
  background-color: #e0e0e0;
  background-image: linear-gradient(
    90deg,
    #e0e0e0 0px,
    #f5f5f5 40px,
    #e0e0e0 80px
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${skeletonLoading} 1.2s infinite linear;
`;

export const Container = styled.div`
  font-family: "Sora";
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: 100dvw;
  overflow-y: auto;
  background: linear-gradient(
    179.67deg,
    rgba(64, 229, 160, 0.94) 0.31%,
    rgba(64, 229, 160, 0.47) 75.74%,
    rgba(64, 229, 160, 0) 91.98%
  );
`;

export const BannerContent = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: -1;
`;

export const ContentView = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  background-color: #eff1f5;
  padding: 1rem 1.7rem 2rem 1.7rem;
  box-sizing: border-box;
  gap: 1.5rem;
`;
